// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__5rZPQ","modalContainer":"Modal_modalContainer__xtod3"};